import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { REMIND_OPTIONS, EVENT_KINDS, toLocalInput, fromLocalInput } from "@/lib/plannerOptions";
import { LinkSelect, linkPayload } from "@/components/scan/LinkSelect";
import { AssigneeSelect } from "@/components/planner/AssigneeSelect";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const blank = (start, remind) => ({ title: "", kind: "APPOINTMENT", start, end: "", location: "", notes: "", remind: String(remind ?? 60), assignee_id: null, link: {} });

export const EventDialog = ({ open, editing, defaultStart, defaultRemind, onClose, onSaved }) => {
  const [f, setF] = useState(blank(""));
  const set = (p) => setF((x) => ({ ...x, ...p }));
  useEffect(() => {
    if (!open) return;
    setF(editing ? { ...editing, start: toLocalInput(editing.start), end: toLocalInput(editing.end), remind: editing.remind_minutes == null ? "none" : String(editing.remind_minutes),
      link: { customer_id: editing.customer_id, portfolio_id: editing.portfolio_id } } : blank(defaultStart, defaultRemind));
  }, [open, editing]);

  const submit = async (e) => {
    e.preventDefault();
    const body = { title: f.title, kind: f.kind, start: fromLocalInput(f.start), end: fromLocalInput(f.end), location: f.location, notes: f.notes,
      remind_minutes: f.remind === "none" ? null : Number(f.remind), assignee_id: f.assignee_id, ...linkPayload(f.link) };
    try {
      if (editing) await api.put(`/events/${editing.id}`, body);
      else await api.post("/events", body);
      toast.success("Takvime kaydedildi");
      onSaved();
      onClose();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="event-dialog">
        <DialogHeader><DialogTitle>{editing ? "Kaydı düzenle" : "Takvime ekle"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-3 gap-3">
            <div>
              <Label className="text-xs">Tür</Label>
              <Select value={f.kind} onValueChange={(v) => set({ kind: v })}>
                <SelectTrigger data-testid="event-kind"><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(EVENT_KINDS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="col-span-2"><Label className="text-xs">Başlık *</Label><Input data-testid="event-title" required minLength={2} value={f.title} onChange={(e) => set({ title: e.target.value })} /></div>
            <div className="col-span-2"><Label className="text-xs">Başlangıç *</Label><Input data-testid="event-start" type="datetime-local" required value={f.start} onChange={(e) => set({ start: e.target.value })} /></div>
            <div>
              <Label className="text-xs">Hatırlatma</Label>
              <Select value={f.remind} onValueChange={(v) => set({ remind: v })}>
                <SelectTrigger data-testid="event-remind"><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(REMIND_OPTIONS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="col-span-2"><Label className="text-xs">Bitiş</Label><Input data-testid="event-end" type="datetime-local" value={f.end} onChange={(e) => set({ end: e.target.value })} /></div>
            <AssigneeSelect testid="event-assignee" value={f.assignee_id} onChange={(v) => set({ assignee_id: v })} />
          </div>
          <div><Label className="text-xs">Konum</Label><Input data-testid="event-location" value={f.location || ""} onChange={(e) => set({ location: e.target.value })} /></div>
          <LinkSelect value={f.link} onChange={(v) => set({ link: v })} />
          <div><Label className="text-xs">Not</Label><Textarea rows={2} value={f.notes || ""} onChange={(e) => set({ notes: e.target.value })} /></div>
          <div className="flex justify-end gap-2"><Button type="button" variant="outline" onClick={onClose}>İptal</Button><Button data-testid="event-save-btn" type="submit" className="bg-emerald-600 hover:bg-emerald-700">Kaydet</Button></div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
